// extracted by mini-css-extract-plugin
module.exports = {"Container":"SemanticInput_Container__19m4x","Invalid":"SemanticInput_Invalid__3-iek","ValidationError":"SemanticInput_ValidationError__y30Sg","Label":"SemanticInput_Label__2leoQ"};